import { LoadingIndicator } from "components/Progress";

export const SplashLoading = () => {
  return (
    <div className="w-full min-h-screen flex justify-center items-center">
      <LoadingIndicator size={72}/>
    </div>
  );
};
